import React, { useEffect, useState } from "react";
import "./style.css";

const API = "https://api.europeanathletic.com";

export default function AdminCash() {

  // ==============================
  // AUTH
  // ==============================
  const [authorized, setAuthorized] = useState(false);
  const [password, setPassword] = useState("");

  // ==============================
  // DATA
  // ==============================
  const [competitions, setCompetitions] = useState([]);
  const [classes, setClasses] = useState([]);
  const [services, setServices] = useState([]);

  const [selectedCompetition, setSelectedCompetition] = useState(null);
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);

  // ==============================
  // USER INPUT
  // ==============================
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [emailConfirm, setEmailConfirm] = useState("");

  const [acceptedTerms, setAcceptedTerms] = useState(false);

  const [success, setSuccess] = useState(false);

  // ==============================
  // LOAD COMPETITIONS
  // ==============================
  useEffect(() => {
    fetch(API + "/api/competitions")
      .then(res => res.json())
      .then(setCompetitions);
  }, []);

  // ==============================
  // LOAD CLASSES + SERVICES
  // ==============================
  useEffect(() => {
    if (!selectedCompetition) {
      setClasses([]);
      setServices([]);
      return;
    }

    fetch(API + `/api/classes?competition_id=${selectedCompetition}`)
      .then(res => res.json())
      .then(setClasses);

    fetch(API + `/api/services?competition_id=${selectedCompetition}`)
      .then(res => res.json())
      .then(setServices);

  }, [selectedCompetition]);

  // ==============================
  // LOGIC
  // ==============================
  const toggleClass = (id) => {
    if (selectedClasses.includes(id)) {
      setSelectedClasses(selectedClasses.filter(c => c !== id));
    } else {
      setSelectedClasses([...selectedClasses, id]);
    }
  };

  const getTotal = () => {
    let total = 0;

    services.forEach(s => {
      if (selectedServices.includes(s.id)) {
        total += Number(s.price);
      }
    });

    if (selectedClasses.length > 2) {
      const extra = selectedClasses.length - 2;
      total += extra * 10;
    }

    return total;
  };

  const isEmailValid = () => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const isValid = () => {
    return (
      selectedCompetition &&
      selectedClasses.length > 0 &&
      name &&
      email &&
      emailConfirm &&
      email === emailConfirm &&
      isEmailValid() &&
      acceptedTerms
    );
  };

  const resetForm = () => {
    setSelectedCompetition(null);
    setSelectedClasses([]);
    setSelectedServices([]);
    setName("");
    setEmail("");
    setEmailConfirm("");
    setAcceptedTerms(false);
  };

  // ==============================
  // CASH SUBMIT
  // ==============================
  const payCash = async () => {

    await fetch(API + "/api/orders", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-internal": "true"
      },
      body: JSON.stringify({
        competition_id: selectedCompetition,
        customer_name: name,
        email: email,
        items: [
          ...selectedClasses.map(id => ({
            type: "class",
            ref_id: id
          })),
          ...selectedServices.map(id => ({
            type: "service",
            ref_id: id
          }))
        ],
        payment_type: "CASH"
      })
    });

    setSuccess(true);
  };

  // ==============================
  // LOGIN SCREEN
  // ==============================
  if (!authorized) {
    return (
      <div style={{ maxWidth: 400, margin: "100px auto", textAlign: "center" }}>
        <h2>🔒 Cash Login</h2>

        <input
          type="password"
          placeholder="Passwort"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{ width: "100%", padding: 10, marginBottom: 10 }}
        />

        <button
          onClick={() => {
            if (password === "!Alex10021992!") {
              setAuthorized(true);
            } else {
              alert("Falsches Passwort");
            }
          }}
          style={{ width: "100%", padding: 12 }}
        >
          Login
        </button>
      </div>
    );
  }

  // ==============================
  // SUCCESS SCREEN
  // ==============================
  if (success) {
    return (
      <div style={{ maxWidth: 600, margin: "100px auto", textAlign: "center" }}>
        <h2>✅ Barzahlung gespeichert</h2>

        <button
          style={{ marginTop: 20, padding: 15 }}
          onClick={() => {
            resetForm();
            setSuccess(false);
          }}
        >
          Neue Buchung
        </button>
      </div>
    );
  }

  // ==============================
  // MAIN UI (IDENTISCH)
  // ==============================
  return (
    <div className="container" style={{ maxWidth: 800, margin: "auto", padding: 30 }}>
      <h1>Order your Media Package</h1>

      <h2>Competition</h2>
      <select
        value={selectedCompetition || ""}
        onChange={(e) => {
          setSelectedCompetition(Number(e.target.value));
          setSelectedClasses([]);
          setSelectedServices([]);
        }}
        style={{ width: "100%", marginBottom: 10, padding: 10 }}
      >
        <option value="">Select Competition</option>
        {competitions.map(c => (
          <option key={c.id} value={c.id}>{c.name}</option>
        ))}
      </select>

      <h2>Additional Services</h2>
      <select
        value={selectedServices[0] || ""}
        onChange={(e) => {
          const value = Number(e.target.value);
          if (!value) {
            setSelectedServices([]);
            return;
          }
          setSelectedServices([value]);
        }}
        style={{ width: "100%", marginBottom: 20, padding: 10 }}
      >
        <option value="">Service auswählen</option>
        {services.map(s => (
          <option key={s.id} value={s.id}>
            {s.name} (€{s.price})
          </option>
        ))}
      </select>

      <h2>Choose your Classes</h2>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 10 }}>
        {classes.map(c => (
          <label key={c.id} style={{ border: "1px solid #ddd", padding: 10 }}>
            <input
              type="checkbox"
              checked={selectedClasses.includes(c.id)}
              onChange={() => toggleClass(c.id)}
            />
            {c.name}
          </label>
        ))}
      </div>

      <h2>Your Details</h2>

      <input
        placeholder="Full Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        style={{ width: "100%", marginBottom: 10, padding: 10 }}
      />

      <input
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        style={{ width: "100%", marginBottom: 10, padding: 10 }}
      />

      <input
        placeholder="Confirm Email"
        value={emailConfirm}
        onChange={(e) => setEmailConfirm(e.target.value)}
        style={{ width: "100%", marginBottom: 20, padding: 10 }}
      />

      <h2>Total: €{getTotal()}</h2>

      <div style={{ marginBottom: 20 }}>
        <label>
          <input
            type="checkbox"
            checked={acceptedTerms}
            onChange={(e) => setAcceptedTerms(e.target.checked)}
          />
          {" "}Ich akzeptiere die{" "}
          <a href="https://europeanathletic.com/agb/" target="_blank">
            AGB
          </a>{" "}
          und die{" "}
          <a href="https://europeanathletic.com/privacy-policy/" target="_blank">
            Datenschutzerklärung
          </a>
        </label>
      </div>

      <button
        style={{
          width: "100%",
          padding: 15,
          background: "green",
          color: "white",
          border: "none",
          fontSize: 16
        }}
        disabled={!isValid()}
        onClick={payCash}
      >
        💵 Barzahlung buchen
      </button>

    </div>
  );
}
